import type { ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { LoadingBlur, Panel } from '@ics-portal/guardian';
import { GET_SECURITY_NOTIFICATIONS_FOR_COMPONENT } from '@api/queries/notifications';
import InfoCardWrapper from '@components/_molecules/InfoCards/Layout/InfoCardWrapper';
import { type ComponentProps } from '../../models/ComponentProps';
import { NotificationsList } from './NotificationsList';

export function NotificationsDetailsTab({
    component,
}: ComponentProps): ReactNode {
    const { data, loading } = useQuery(
        GET_SECURITY_NOTIFICATIONS_FOR_COMPONENT,
        {
            variables: { id: component.id },
        },
    );

    const notifications =
        data?.notifications.edges
            .map((edge) => edge.node)
            .filter(Boolean)
            .map((notification) => ({
                value: notification.id,
                label: notification.title,
            })) || [];

    return (
        <InfoCardWrapper title="Security notifications">
            <LoadingBlur loading={loading}>
                <Panel header="Related security notifications">
                    <NotificationsList notifications={notifications} />
                </Panel>
            </LoadingBlur>
        </InfoCardWrapper>
    );
}
